import { combineReducers } from 'redux';
import alertReducer from '../store/AlertMessages/reducer';

export default combineReducers({
    alertReducer
});